import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { IPasswordFormData } from '@interfaces/administracja/user-access/uzytkownicy.interface';
import { PermissionDto } from '@interfaces/permissions.interface';
import { ApiBaseService } from '@services/api-base.service';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';

const endpoint = `${environment.apiUrl}/user-access/users`;

@Injectable({
  providedIn: 'root',
})
export class UsersService extends ApiBaseService {
  readonly permissions$: BehaviorSubject<PermissionDto[]> = new BehaviorSubject([]);

  get permissionsCodes(): string[] {
    return this.permissions$.value.length ? this.permissions$.value.map((el) => el.code) : [];
  }

  putPassword(passwordData: IPasswordFormData): Observable<null> {
    return this.http.put<null>(`${endpoint}/password`, passwordData);
  }

  loadPermissions(): void {
    this.getPermissions().subscribe((permissions) => {
      this.permissions$.next(permissions);
    });
  }

  doesUserHavePermission(expectedPermissionCode: string): Observable<boolean> {
    return this.permissions$.pipe(
      filter(Boolean),
      map((userPermissions: PermissionDto[]) =>
        userPermissions.some((permission: PermissionDto) => permission.code === expectedPermissionCode),
      ),
    );
  }

  private getPermissions(): Observable<PermissionDto[]> {
    return this.http.get<PermissionDto[]>(`${endpoint}/permissions`);
  }
}
